import * as React from "react";

export const useSelection = (defaultSelected?: string) => {
  const [selected, setSelected] = React.useState(defaultSelected || "");
  const select = React.useCallback((key: string, reset?: boolean) => {
    const _reset = reset || true;
    setSelected((prevState) => {
      if (_reset) {
        return prevState === key ? "" : key;
      }
      return key;
    });
  }, []);
  const unselect = React.useCallback(() => {
    setSelected("");
  }, []);
  const isSelected = React.useCallback(
    (key: string) => {
      return key === selected;
    },
    [selected]
  );

  return { select, unselect, isSelected, selected };
};
